<template>
    <div @click="()=>{collection(id,collections)  }" class="pointer">
        <i v-if="!loading" :class="collections==null?  'iconfont icon-shoucang':'iconfont icon-collection-b'"></i>
        <i v-else class="el-icon-loading"></i>
    </div>
</template>

<script>
    export default {
        props: {
            id: {
                type: Number
            },
            account_id: {
                type: String
            },
            taxonomy: {
                type: String
            },
            collections: {
                type: Object
            }
        },
        data() {
            return {
                loading: false
            }
        },
        methods: {
            collection(id, iscollect) {
                if (this.loading) {
                    return false;
                }
                this.loading = true
                if (iscollect == null) {
                    this.$http
                        .post("collection", {
                            resource_id: id,
                            taxonomy: this.taxonomy
                        })
                        .then(response => {
                            if (response.success) {
                                this.$emit("change", response.data);
                            }else
                            {
                                this.$alert(response.message, "操作失败", {
                                    type: "error"
                                });
                            }
                        }).catch().then(() => this.loading = false);
                } else {
                    this.$emit("change", false);
                    this.$http.delete("collection/" + iscollect["id"]).then(response => {
                        if (!response.success) {
                            this.$emit("change", null);
                        }
                    }).catch().then(() => this.loading = false);
                }
            }
        }
    };

</script>
<style scoped lang="scss">
    @import './../../../config.scss';

    .icon-collection-b {
        color: $--color-primary;
    }

</style>



// WEBPACK FOOTER //
// src/components/_widget/Operation.vue